import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { HomeProductSection } from '../home-product/HomeProductSection'

import soundcoreLogo from 'shared/assets/logos/soundcore.svg'
import pluginsIcon from '../home-product/assets/plugins.svg'
import databaseIcon from '../home-product/assets/database.svg'
import cloudBrainIcon from '../home-product/assets/cloud-brain.svg'
import soundcoreDesktopBg from '../home-product/assets/product-feature-display-soundcore-desktop-bg.jpeg'
import soundcoreMobileBg from '../home-product/assets/product-feature-display-soundcore-mobile-bg.jpg'

export const SoundcoreSection: React.FC = () => {
  const navigate = useNavigate()

  const handleSoundcoreClick = () => {
    navigate('/soundcore')
  }

  return (
    <HomeProductSection
      logoUrl={soundcoreLogo}
      text="Build complex tools with greater speed, novel creativity, and GPU-powered scalability"
      buttonText="Explore Soundcore"
      onButtonClick={handleSoundcoreClick}
      desktopBackgroundUrl={soundcoreDesktopBg}
      mobileBackgroundUrl={soundcoreMobileBg}
      featureCards={[
        {
          icon: pluginsIcon,
          text: "Accelerate Plugin Development"
        },
        {
          icon: databaseIcon,
          text: "Increase Instance Count"
        },
        {
          icon: cloudBrainIcon,
          text: "Run Edge-to-Cloud Neural Models"
        }
      ]}
    />
  )
}